import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/operated/achievement',
  owner: '/home',
  authority: 'achievementList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};